import type { CSSProperties } from 'react'
import { getNlsString } from '../../nls/nlsRuntime'
import { useShortLoad } from './useShortLoad'

type MiniLoaderTone = 'default' | 'upload' | 'ai'
type MiniLoaderSize = 'xs' | 'sm' | 'md'

type MiniLoaderProps = {
  label?: string
  tone?: MiniLoaderTone
  size?: MiniLoaderSize
  className?: string
  inline?: boolean
  style?: CSSProperties
}

export const MiniLoader = ({
  label,
  tone = 'default',
  size = 'sm',
  className,
  inline = false,
  style,
}: MiniLoaderProps) => {
  const visible = useShortLoad(true)

  const classes = [
    'miniLoader',
    `miniLoader--${tone}`,
    `miniLoader--${size}`,
    inline ? 'miniLoader--inline' : '',
    className ?? '',
  ].filter(Boolean).join(' ')

  const rootStyle: CSSProperties = visible
    ? (style ?? {})
    : { ...style, visibility: 'hidden' }

  return (
    <span
      className={classes}
      style={rootStyle}
      role="status"
      aria-live="polite"
      aria-label={label ?? getNlsString('NLSCommonStatusLoading')}
      data-short-load={visible ? undefined : 'pending'}
    >
      <span className="miniLoader__orb" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      {label ? <span className="miniLoader__label">{label}</span> : null}
    </span>
  )
}
